interface FilterBarProps {
  years: number[];
  genres: string[];
  year: string;
  genre: string;
  sort: string;
  onChange: (patch: Record<string, string>) => void;
}

const selectClass =
  "h-10 px-3 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-800 outline-none focus:border-primary-400 cursor-pointer";

export default function FilterBar({ years, genres, year, genre, sort, onChange }: FilterBarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200 flex-wrap">
      <span className="hidden sm:flex items-center gap-1.5 text-sm text-foreground-500">
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-filter-3-line"></i>
        </span>
        筛选
      </span>

      <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-3">
        <label className="flex flex-col sm:flex-row sm:items-center gap-1.5 text-sm text-foreground-600">
          <span className="whitespace-nowrap">上映年份</span>
          <select
            value={year}
            onChange={(e) => onChange({ year: e.target.value })}
            className={selectClass}
          >
            <option value="all">全部年份</option>
            {years.map((item) => (
              <option key={item} value={String(item)}>
                {item} 年
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col sm:flex-row sm:items-center gap-1.5 text-sm text-foreground-600">
          <span className="whitespace-nowrap">作品类型</span>
          <select
            value={genre}
            onChange={(e) => onChange({ genre: e.target.value })}
            className={selectClass}
          >
            <option value="all">全部类型</option>
            {genres.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col sm:flex-row sm:items-center gap-1.5 text-sm text-foreground-600 col-span-2 sm:col-span-1">
          <span className="whitespace-nowrap">排序方式</span>
          <select
            value={sort}
            onChange={(e) => onChange({ sort: e.target.value })}
            className={selectClass}
          >
            <option value="latest">默认 · 最新上线</option>
            <option value="views">按点击量</option>
          </select>
        </label>
      </div>
    </div>
  );
}